import { InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { useIntl } from 'react-intl';

const ImsStyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    height: 36,
    paddingRight: '40px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ddd',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ccc',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ccc',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '0.8rem',
    color: '#555',
    paddingLeft: '12px',
    paddingRight: '40px',
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '0.8rem',
    color: '#999',
    opacity: 1,
  },
}));

const ImsTextField = ({ value, onChange, onKeyDown, placeholderId, icon, ...props }: any) => {
  const intl = useIntl();
  const placeholderText = intl.formatMessage({ id: placeholderId });

  return (
    <ImsStyledTextField
      {...props}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholderText}
      InputProps={{
        notched: false,
        endAdornment: icon ? (
          <InputAdornment position="end" sx={{ color: '#999', position: 'absolute', right: '10px' }}>
            {icon}
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default ImsTextField;
